import React from "react";
import { object } from "prop-types";
import { Helmet } from "react-helmet";

const getLdJson = data =>
	data.map(i => ({
		"@type": "Question",
		name: i.cardText,
		acceptedAnswer: {
			"@type": "Answer",
			text: i.cardContentComponents?.pageSections?.[0].content?.childMarkdownRemark?.html,
		},
	}));
const getFAQAccordionData = data => {
	const nodes = [];

	const findNode = section => {
		switch (section?.sys?.contentType?.sys?.id) {
			case "tabsAndAccordions":
				if (section?.style === "FAQs") nodes.push(...section?.cards);
				break;
			case "componentWrapper":
				// eslint-disable-next-line no-unused-expressions
				section?.wrapperSections?.pageSections?.forEach(i => {
					findNode(i);
				});
				break;
			default:
				break;
		}
	};
	// eslint-disable-next-line no-unused-expressions
	data?.pageSections?.forEach(i => {
		findNode(i);
	});
	return nodes;
};

const FAQs = ({ data }) => {
	const ldJson = data ? getLdJson(getFAQAccordionData(data)) : [];
	return (
		!!ldJson?.length && (
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify(
						{
							"@context": "https://schema.org",
							"@type": "FAQPage",
							mainEntity: ldJson,
						},
						null,
						4
					)}
				</script>
			</Helmet>
		)
	);
};

FAQs.propTypes = {
	data: object.isRequired,
};

export default FAQs;
export { FAQs };
